import bg1 from "../../Assets/img/Banner1.png";
import bg2 from "../../Assets/img/Banner2.png";
import bg3 from "../../Assets/img/Banner3.png";

const SliderData = [
  {
    id: 1,
    subTitle: [
      <div>
        Choose <span> OKC UPTOWN </span> <br /> for Unmatched Quality.
      </div>,
    ],
    link: "",
    img: bg1,
  },
  {
    id: 2,
    subTitle: [
      <div>
        Years of <span>excellence</span> , <br /> a track record you can trust.
      </div>,
    ],
    link: "",
    img: bg2,
  },
  {
    id: 3,
    subTitle: [
      <div>
        Your <span>satisfaction</span> <br /> is our unwavering commitment.
      </div>,
    ],
    link: "",
    img: bg3,
  },
];

export default SliderData;
